enum SorterEnum {
  ASC,
  DESC
}

export default SorterEnum;
